const types = {
  SET_RESULT_STATUS: "SET_RESULT_STATUS",
  SET_INPUT_FOR_RESULT: "SET_INPUT_FOR_RESULT",
  SET_LAT_LONG: "SET_LAT_LONG",
  SET_QUALITYSCHEME_FILTERED: "SET_QUALITYSCHEME_FILTERED" 
};

export { types };